import {usePreviewContext} from "../../context/PreviewContext";
import {metaDataForPlacement} from "./previewMetaData";
import React, {useEffect} from "react";

interface Props {
    placementName?: string,
    children: any,
    hasItems?: boolean
}

function PreviewPlacementHighlighter(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const [isMounted, setIsMounted] = React.useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return <>{props.children}</>
    }

    if (isPreview && props.placementName) {
        return <span {...metaDataForPlacement(isPreview, props.placementName, props.hasItems)}>{props.children}</span>
    } else {
        return <>{props.children}</>
    }
}

export default PreviewPlacementHighlighter;